document.addEventListener('DOMContentLoaded', async function () {
  // Firefighter fatalities API calls 2025
  try {
    const res = await fetch('https://apps.usfa.fema.gov/firefighter-fatalities/api/stateJson?year=2025');

    if (!res.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await res?.json()
    document.querySelector('.fffatcount25').appendChild(document.createTextNode(data.total));

  } catch (error) {
    throw new Error(error)
  }

  // Civilian fatalities API calls 2025
  try {
    const res = await fetch('https://apps.usfa.fema.gov/civilian-fatalities/api/stateJson');

    if (!res.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await res?.json()
    document.querySelector('.civfattotal25').appendChild(document.createTextNode(data.totalThisYear));

  } catch (error) {
    throw new Error(error)
  }
});
